import CommonPanel from "../../common/common-panel";
import { useTranslation } from "react-i18next";

// Charts
import SurveyEmissionChart from "./charts/survey_emission";
import SurveyCompletionStatusChart from "./charts/survey-completion-status";

import { OperationChartData } from "./operation-chartData";

// services
import OperationDetailsService from "../../../services/AuraCamera/operation-details/operation-details.service";
// Table Component

// CSS
import "./survey-details.css";

// Test

import { useEffect, useRef, useState } from "react";

// React Router DOM
import { useParams, useNavigate, Navigate } from "react-router-dom";

// Loading Screen
import LoadingScreen from "../../common/Loading";
import OperationsDetailsMap from "./components/operations-details-map";

import { Dropdown } from "primereact/dropdown";
import Helper from "./../../../utils/helpers";
import TokenService from "../../../services/autentication/token.service";
import Helpers from "./../../../utils/helpers";
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import LeakTab from "./components/map-leak-data-tab";
import RouteDetailsService from "../../../services/AuraCamera/routes/route_details";

const SurveyDetails = () => {
  const { t } = useTranslation();
  const [isLoading, isLoadingUpdate] = useState(false);

  var navigate = useNavigate();
  document.title = "Dashboard-AURA Camera";
  const { surveyDate_url } = useParams();
  const { siteID } = useParams();
  const selectDaysDpDown = useRef<any>(null);
  /* const SurveyDetails_Redux = useSelector(
    (state: AppState) => state.AOGISurveyDetails.SurveyDetailsData
  ); */

  // SUrvey Overview
  const [TotalSites, UpdateTotalSites] = useState(0);
  const [CompletedSites, UpdateCompletedSites] = useState<number>(0);
  const [RemainingSites, UpdateRemainingSites] = useState<number>(0);
  const [SurveyDates, UpdateSurveyDates] = useState<any>([]);
  const [SurveyDatesSelectedOnYear, UpdateSurveyDatesSelectedOnYear] =
    useState<any>([]);
  const [SurveyYears, UpdateSurveyYears] = useState<any>([]);
  const [UnitPrefList, UpdateUnitPrefList] = useState<any>([
    { name: "Metric" },
    { name: "Imperial" },
  ]);

  const [DisplaySiteName, UpdateDisplaySiteName] = useState<any>("");
  const [UnitPrefSelected, UpdateUnitPrefSelected] = useState<any>([]);
  const [SurveySelectedYears, UpdateSurveySelectedYears] = useState<any>([]);
  const [selectedSurveyDate, setSelectedSurveyDate] = useState<any>([]);

  const [EmissionOverviewData, UpdateEmissionOverviewData] = useState([]);
  const [mapData, updateMapData] = useState<any>([]);
  const [RouteDropdown, updateRouteDropdown] = useState<any>([]);
  const [SelectedRouteDropdown, updateSelectedRouteDropdown] = useState<any>({
    routeName: "All Routes",
  });
  const [FilteredmapData, updateFilteredmapData] = useState<any>([]);
  const [color_binding_array, updatecolor_binding_array] = useState<any>([]);
  const [RouteDetails, SetRouteDetails] = useState<any>([]);
  useEffect(() => {
    isLoadingUpdate(true);
    if (SurveyDates.length == 0) {
      OperationDetailsService.GetSurveyDatesforSite(siteID).then(
        (res_surveyDates: any) => {
          if (res_surveyDates?.length == 0) {
            navigate(`/aura-camera/operations`);
          }
          let temp_surveyDates: any = [];
          let temp_surveyYears: any = [];
          res_surveyDates.forEach((val: any) => {
            // ConvertUtcToLocalReadable
            let year = Helper.ConvertUtcToYear(val);
            if (!temp_surveyYears.includes(year)) {
              temp_surveyYears.push(year);
            }
            temp_surveyDates.push({
              name: Helper.ConvertUtcToLocalReadable(val),
              code: val,
            });
          });
          if (temp_surveyYears.length > 0) {
            let surevyYearWithKey: any = [];
            temp_surveyYears.forEach((val: any) => {
              surevyYearWithKey.push({ name: Number(val) });
            });
            surevyYearWithKey = surevyYearWithKey.sort((a: any, b: any) => {
              return b.name - a.name;
            });
            UpdateSurveyYears(surevyYearWithKey);
          }
          Helpers.GetProper_Custom_Unique_records(
            temp_surveyDates,
            surveyDate_url
          ).then((res_unique_rec: any) => {
            UpdateSurveyDates(res_unique_rec);
          });
        }
      );
    }

    OperationDetailsService.GetSurveyOverviewData(
      selectedSurveyDate.code,
      siteID
    ).then((res_survey_overview_data: any) => {
      UpdateTotalSites(res_survey_overview_data.total);
      UpdateCompletedSites(res_survey_overview_data.completed);
      UpdateRemainingSites(res_survey_overview_data.remaining);
    });

    RouteDetailsService.GetRouteDetails(siteID).then((route_details_res: any) => {
      SetRouteDetails(route_details_res)
    })
    OperationDetailsService.GetMapData(selectedSurveyDate.code, siteID).then(
      (res_mapData: any) => {
        if (color_binding_array?.length == 0) {
          if (res_mapData && res_mapData[0] && res_mapData[0].routes) {
            updatecolor_binding_array(
              Helpers.generateLowContrastHashColors(res_mapData[0]?.routes.length)
            );
          }
        }
        if (res_mapData && res_mapData[0]?.siteName) {
          UpdateDisplaySiteName(res_mapData[0]?.siteName);
        }
        if (res_mapData && res_mapData[0] && res_mapData[0].routes) {
          res_mapData[0]?.routes?.map((val: any, i: any) => {
            val.color = color_binding_array[i];
          });
        }

        updateMapData(res_mapData);
        let prepend_array_data: any = [];
        if (res_mapData && res_mapData[0] && res_mapData[0].routes) {
          prepend_array_data = [
            { routeName: "All Routes" },
            ...res_mapData[0].routes,
          ];
        }
        // let prepend_array_data: any = [
        //   { routeName: "All Routes" },
        //   ...res_mapData[0]?.routes,
        // ];
        //console.log(prepend_array_data)

        updateRouteDropdown(prepend_array_data);
        updateFilteredmapData(res_mapData);
        setTimeout(() => {
          isLoadingUpdate(false);
        }, 1000);
      }
    );

    if (
      SurveyDates.length > 0 &&
      selectedSurveyDate.length == 0 &&
      SurveyYears.length > 0
    ) {
      let temp_survey_url_readable_date =
        Helper.ConvertUtcToLocalReadable(surveyDate_url);
      let year: any = Helper.ConvertUtcToYear(surveyDate_url);
      UpdateSurveySelectedYears({ name: Number(year) });

      setSelectedSurveyDate({
        name: temp_survey_url_readable_date,
        code: surveyDate_url,
      });
      let temp_dynamic_survey_dates: any = [];
      SurveyDates.map((val: any) => {
        let num_year: any = Helper.ConvertUtcToYear(val.code);
        if (year == Number(num_year)) {
          temp_dynamic_survey_dates.push(val);
        }
      });
      UpdateSurveyDatesSelectedOnYear(temp_dynamic_survey_dates);
    }
  }, [SurveyDates, selectedSurveyDate, SurveyYears]);

  useEffect(() => {
    window.scrollTo(0, 0);
    let session = window.localStorage;
    let user: any = TokenService.getUser();

    if (user?.userSettings?.length == 0) {
      session.setItem("UnitPrefWebApp", "Metric");
      UpdateUnitPrefSelected({ name: "Metric" });
    } else {
      if (session.getItem("UnitPrefWebApp") == null) {
        user?.userSettings.map((val: any) => {
          if (val.key == "CurrentUOM") {
            session.setItem("UnitPrefWebApp", val.value);
            UpdateUnitPrefSelected({ name: val.value });
          }
        });
      } else {
        UpdateUnitPrefSelected({ name: session.getItem("UnitPrefWebApp") });
      }
    }
  }, []);

  const SurveyDetails_Redux = OperationChartData;

  // Chart States



  const onCityChange = (e: { value: any }) => {
    setSelectedSurveyDate(e.value);
  };

  const onUnitPrefChange = (e: any) => {
    let session = window.localStorage;
    session.setItem("UnitPrefWebApp", e.value.name);
    UpdateUnitPrefSelected(e.value);
  };
  const onYearChange = (e: any) => {
    let temp_dynamic_survey_dates: any = [];
    SurveyDates.map((val: any) => {
      let num_year: any = Helper.ConvertUtcToYear(val.code);
      if (e.value.name == Number(num_year)) {
        temp_dynamic_survey_dates.push(val);
      }
    });
    UpdateSurveySelectedYears({ name: Number(e.value.name) });
    UpdateSurveyDatesSelectedOnYear(temp_dynamic_survey_dates);
    //
    if (temp_dynamic_survey_dates.length == 1) {
      setSelectedSurveyDate({
        name: temp_dynamic_survey_dates[0].name,
        code: temp_dynamic_survey_dates[0].code,
      });
    } else {
      setSelectedSurveyDate({
        name: temp_dynamic_survey_dates[0].name,
        code: temp_dynamic_survey_dates[0].code,
      });
    }
  };

  const handleRouteonChangeDropdown = (e: any) => {
    updateSelectedRouteDropdown(e.value);
    if (e?.value?.routeName == "All Routes") {
      // send all routes
      updateFilteredmapData(mapData);
    } else {
      // filter

      let filtered_route: any = mapData[0]?.routes.filter((val: any) => {
        return val.routeName == e.value.routeName;
      });
      filtered_route = [
        {
          siteID: mapData[0]?.siteID,
          siteName: mapData[0]?.siteName,
          routes: filtered_route,
        },
      ];

      updateFilteredmapData(filtered_route);
    }
  };
  return (
    <>
      <LoadingScreen isLoading={isLoading} />
      <nav aria-label="breadcrumb" className="breadcrumb--wrapper">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>AURA Camera</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            <a>Operation details</a>
          </li>
        </ol>
      </nav>
      <div className="content__header">
        <div className="content__wrap">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="heading-block">
                <h4 className="page-heading">
                  AURA Operation Details - {DisplaySiteName}
                </h4>
                <div className="dots">
                  <i
                    className="pi pi-ellipsis-v"
                    style={{ fontSize: "1.5em", cursor: "pointer" }}
                    onClick={(e) => {
                      selectDaysDpDown.current.toggle(e);
                    }}
                  ></i>

                  <OverlayPanel ref={selectDaysDpDown}>
                    <Button
                      onClick={() => {
                        navigate(
                          `/aura-camera/route-details/${siteID}`
                        );
                      }}
                    >
                      Route Details for Site
                    </Button>
                  </OverlayPanel>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="banner-feilds--block">
                <div className="field-col-left">
                  <div className="surveydate-inner">
                    <div className="dropcol1">
                      <label className="">
                        <span style={{ marginRight: "5px", fontSize: "12px" }}>
                          Survey years
                        </span>
                      </label>
                      <Dropdown
                        value={SurveySelectedYears}
                        options={SurveyYears}
                        onChange={onYearChange}
                        optionLabel="name"
                        placeholder="Select survey year"
                        height={"10px"}
                      />
                    </div>
                    <div className="dropcol2">
                      <label className="">
                        <span style={{ marginRight: "5px", fontSize: "12px" }}>
                          Survey dates
                        </span>
                      </label>
                      <Dropdown
                        value={selectedSurveyDate}
                        options={SurveyDatesSelectedOnYear}
                        onChange={onCityChange}
                        optionLabel="name"
                        placeholder="Select survey date"
                        height={"10px"}
                      />
                    </div>
                  </div>
                </div>
                <div className="field-col-right">
                  <div className="timelineBlock opdetails-timeline">
                    <div className="timeCol1">
                      <Dropdown
                        value={SelectedRouteDropdown}
                        options={RouteDropdown}
                        onChange={handleRouteonChangeDropdown}
                        optionLabel="routeName"
                        placeholder="Select Route"
                        height={"10px"}
                      />
                    </div>
                    <div className="timeCol2">
                      <Dropdown
                        value={UnitPrefSelected}
                        options={UnitPrefList}
                        onChange={onUnitPrefChange}
                        optionLabel="name"
                        placeholder="Select Unit Pref."
                        height={"10px"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="content__boxed">
        <div className="content__wrap">
          {/* Grid Main Div */}
          <div className="aogi_survey_details_upper_div">
            {/* one */}
            <div className="card aogi_survey_details_survey_overview">
              <div className="panel_div">
                <span
                  className="common_panel_heading_test"
                  data-pr-position="top"
                  data-pr-at="right+5 top"
                  data-pr-my="left center-2"
                  style={{ fontSize: "4rem" }}
                >
                  <span>{t("SurveyDetails.SurveyOverviewHeader")}</span>
                </span>
              </div>
              <div className="card-body survey_details_card_body">
                <table className="survey_details_card_table">
                  <tr>
                    <td>Total Equipment (Targets) </td>
                    <td className="bold-values-table">{TotalSites}</td>
                  </tr>
                  <tr>
                    <td>{t("SurveyDetails.CompletedText")} </td>
                    <td className="bold-values-table">{CompletedSites}</td>
                  </tr>
                  <tr>
                    <td>{t("SurveyDetails.RemainingText")} </td>
                    <td className="bold-values-table">{RemainingSites}</td>
                  </tr>
                </table>
              </div>
            </div>
            {/* three */}
            <div className="card operation-details-map-panel">
              <div className="card">
                <CommonPanel
                  InnerComponent={
                    <OperationsDetailsMap
                      filteredValues={""}
                      mapData={FilteredmapData}
                    />
                  }
                  Heading={`Map`}
                />
              </div>
            </div>
            {/* four */}
            <div className="card aogi_survey_details_survey_completion_status">
              <div className="card">
                <CommonPanel
                  InnerComponent={
                    <SurveyCompletionStatusChart
                      TotalSites={TotalSites}
                      RemainingSites={RemainingSites}
                      CompletedSites={CompletedSites}
                      SurveyDetails_Redux={SurveyDetails_Redux}
                    />
                  }
                  Heading={`${t("SurveyDetails.SurveyCompleteHeader")}`}
                />
              </div>
            </div>
            {/* <br className="d-md-none" /> */}
            <div className="card aogi_survey_details_survey_emission">
              <div className="card">
                <CommonPanel
                  InnerComponent={
                    <SurveyEmissionChart
                      SurevyEmission={EmissionOverviewData}
                      mapData={FilteredmapData}
                    // SurveyDetails_Redux={SurveyDetailsData}
                    />
                  }
                  Heading={`${t("SurveyDetails.SurveyEmissionHeader")}`}
                />
              </div>
            </div>
            <div className="card operation-details-table-panel">
              <div className="card">
                <CommonPanel
                  InnerComponent={<LeakTab FilteredmapData={FilteredmapData} RouteDetails={RouteDetails}></LeakTab>}
                  Heading={`Survey Details`}
                />
              </div>
            </div>
          </div>
          {/* <article className="d-md-flex gap-4">
            <div className="flex-fill">
              <section id="boxed-layout-tips" className="card mb-4">
                <div className="card">
                  <div className="card flex map-wapper">
                    <div className="map-col">
                      <div className="map-col-inner">
                         <LeakTab FilteredmapData={FilteredmapData} RouteDetails={RouteDetails}></LeakTab> 
                         <OperationsDetailsMap
                          filteredValues={""}
                          mapData={FilteredmapData}
                        /> 
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </article> */}
        </div>
      </div>
    </>
  );
};

export default SurveyDetails;
